<template>
  <div v-if="loadedData" class="apply-detail">
    <div class="container__table">
      <div class="new-search">
        <div class="new-search__header">
          <h3 class="new-search__title">{{ $t("apply.title") }} {{profileData.personalInformation.firstName}}</h3>
        </div>
        <div class="new-search__grid">
          <div class="section-container">
            <h3><span class="material-icons">account_circle</span>{{ $t("apply.personalInfo") }}</h3>
            <template v-if="loadedData">
              <div class="apply-detail__information">
                <div class="apply-detail__information__photo" :style="`background-image: url(${getImage(profileData.personalInformation.picture) || require('@/assets/placeholder.png')})`">
                </div>
                <div class="apply-detail__information__details">
                  <div>{{ $t("apply.firstName") }} <b>{{profileData.personalInformation.firstName}}</b></div>
                  <div>{{ $t("apply.lastName") }} <b>{{profileData.personalInformation.lastName}}</b></div>
                  <div>{{ $t("apply.age") }} <b>{{profileData.personalInformation.age}}</b></div>
                  <div>{{ $t("apply.gender") }} <b>{{profileData.personalInformation.genderName}}</b></div>
                  <div v-if="profileData.personalInformation.selfPerceivedGender !== null && profileData.personalInformation.selfPerceivedGender !==''">{{ $t("apply.selfPerceivedGender") }} <b>{{profileData.personalInformation.selfPerceivedGender}}</b></div>
                  <div v-if="profileData.aboutMe.profileInterest.length > 0">{{ $t("apply.profileInterest") }} <b>{{ profileData.aboutMe.profileInterest.map(x => x.name).join(', ') }}</b></div>
                </div>
              </div>

              <!-- test forge -->
              <div class="test-forge" v-if="profileData.aptitudeScore != null && Object.keys(profileData.aptitudeScore).length > 0">
                <h3>Evaluación de aptitudes Forge</h3>
                <div class="test-forge__skills">
                  <template v-for="(score,skill) in profileData.aptitudeScore" :key="skill">
                    <div class="test-forge__skill">
                      <span class="test-forge__skill__name">{{$t(`apply.testForge.${skill}`)}}:</span>
                      <span class="test-forge__skill__score">
                        <template v-for="s in [1,2,3,4,5]" :key="s">
                          <i class="material-icons" :class="{'star-painted':s*20 <= score}">star</i>
                        </template>
                      </span>
                    </div>
                  </template>
                </div>
              </div>

            </template>
            <div v-else class="detail-skeleton-container" >
              <Skeletor width="500" height="16"/>
              <Skeletor width="300" height="16"/>
              <Skeletor width="500" height="16"/>
              <Skeletor width="300" height="16"/>
            </div>
            <!-- <div><b>{{ $t("apply.selfPerceivedGender") }}:</b> {{profileData.personalInformation.selfPerceivedGenderId}}</div> -->
          </div>
          <template v-if="loadedData && profileData.aboutMe.whatMakesMeUniq && profileData.aboutMe.whatMakesMeUniq != ''">
            <div class="section-container">
              <h3><span class="material-icons">email</span>{{ $t("apply.whatMakesMeUniq") }}</h3>
              <div>{{profileData.aboutMe.whatMakesMeUniq}}</div>
            </div>
          </template>
          <template v-if="loadedData && profileData.aboutMe.whatMakesMeUniq && profileData.aboutMe.whatMakesMeUniq != ''">
            <div class="section-container">
              <h3><span class="material-icons">collections</span>{{ $t("apply.myPhotos") }}</h3>
              <div class="my-photos__item">
                <img v-for="photo in profileData.aboutMe.photos" :key="photo" :src="getImage(photo.picture)">
              </div>
            </div>
          </template>
           <div class="section-container">
              <h3><span class="material-icons">games</span>{{ $t("apply.gamesInfo") }}</h3>
              <template v-if="loadedData">
                <div class="card-container card-container--games">
                  <template v-for="game in profileData.games" :key="game.id">
                    <div class="card card--games">
                      <div class="card__image">
                          <img :src="game.picture">
                      </div>
                      <div class="card__info">
                        <div class="card__info__title">{{game.name}}</div>
                        <div class="card__info__description">{{game.description}}</div>
                        <div class="card__info__status" :class="`card__info__status--${game.status}`" >{{ $t(`apply.games.status.${game.status}`) }}</div>
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="profileData.games.length == 0">
                  {{ $t("apply.games.no-info") }}
                </div>
              </template>
              <template v-else>
                <div class="card-container">
                  <div class="card card--games" v-for="index in 4" :key="index">
                    <div class="card__image">
                        <Skeletor size="100" />
                    </div>
                    <div class="card__info">
                      <div class="card__info__title"><Skeletor width="50%" height="20"/></div>
                      <div class="card__info__description"><Skeletor width="100%%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="100%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="75%" height="16"/></div>
                    </div>
                  </div>
                </div>
              </template>
          </div> 
          <div class="section-container">
              <h3><span class="material-icons">school</span>{{ $t("apply.studyAcademicsInfo") }}</h3>
              <template v-if="loadedData">
                <div class="card-container">
                  <div class="card card--study" v-for="academics in profileData.study.academics" :key="academics.id">
                    <div class="card__info">
                      <div class="card__info__title">{{academics.educationalInstitutionName == '' ? academics.educationalInstitutionOther : academics.educationalInstitutionName}} 
                        {{(academics.educationSpecialtyName != "" && academics.educationSpecialtyName != null) || (academics.educationSpecialtyOther != "" && academics.educationSpecialtyOther != null) ? '-':''}} {{academics.educationSpecialtyName == "" ? academics.educationSpecialtyOther : academics.educationSpecialtyName}}</div>
                      <div class="card__info__description"><b>{{ $t("apply.studyAcademics.status") }}:</b> {{academics.Finished ? $t("apply.studyAcademics.statusFinished") : $t("apply.studyAcademics.statusInProgress")}}</div>
                      <div class="card__info__description"><b>{{ $t("apply.studyAcademics.dateRange") }}:</b> {{academics.fromYear}} - {{academics.toYear != null ? academics.toYear : $t("apply.current")}}</div>
                    </div>
                  </div>
                </div>
                <div v-if="profileData.study.academics.length == 0">
                    {{ $t("apply.studyAcademics.no-info") }}
                </div>
              </template>
              <template v-else>
                <div class="card-container">
                  <div class="card card--study" v-for="index in 4" :key="index">
                    <div class="card__info">
                      <div class="card__info__title"><Skeletor width="50%" height="20"/></div>
                      <div class="card__info__description"><Skeletor width="100%%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="100%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="75%" height="16"/></div>
                    </div>
                  </div>
                </div>
              </template>

              <h3 style="margin-top: 24px"><span class="material-icons">language</span>{{ $t("apply.studyLanguageInfo") }}</h3>
              <template v-if="loadedData">
                <div class="card-container">
                  <div class="card card--study" v-for="language in profileData.study.languages" :key="language.id">
                    <div class="card__info">
                      <div class="card__info__title">{{language.languageKnowledgeName}}</div>
                      <div class="card__info__description"><b>{{ $t("apply.studyLanguage.level") }}:</b> {{$t(`apply.studyLanguage.level_${language.level}`)}}</div>
                    </div>
                  </div>
                </div>
                <div v-if="profileData.study.languages.length == 0">
                    {{ $t("apply.studyLanguage.no-info") }}
                </div>
              </template>
              <template v-else>
                <div class="card-container">
                  <div class="card card--study" v-for="index in 4" :key="index">
                    <div class="card__info">
                      <div class="card__info__title"><Skeletor width="50%" height="20"/></div>
                      <div class="card__info__description"><Skeletor width="100%%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="100%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="75%" height="16"/></div>
                    </div>
                  </div>
                </div>
              </template>
          </div> 
          <div class="section-container">
              <h3><span class="material-icons">work</span>{{ $t("apply.workInfo") }}</h3>
              <template v-if="loadedData">
                <div class="card-container">
                  <div class="card card--job" v-for="job in profileData.jobs" :key="job.id">
                    <div class="card__info">                     
                      <div class="card__info__title">{{job.organizationId != null ? job.organizationName : job.organizationOther}}</div>
                      <div class="card__info__description">{{job.description}}</div>
                      <div class="card__info__description"><b>{{ $t("apply.jobs.position") }}:</b> {{job.positionId != null ? job.positionName : job.positionOther}}</div>
                      <div class="card__info__description"><b>{{ $t("apply.jobs.dateRange") }}:</b> {{formatDate(job.from)}} - {{formatDate(job.to)}}</div>
                    </div>
                  </div>
                </div>
                <div v-if="profileData.jobs.length == 0">
                    {{ $t("apply.jobs.no-info") }}
                </div>
              </template>
              <template v-else>
                <div class="card-container">
                  <div class="card card--job" v-for="index in 4" :key="index">
                    <div class="card__info">
                      <div class="card__info__title"><Skeletor width="50%" height="20"/></div>
                      <div class="card__info__description"><Skeletor width="100%%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="100%" height="16"/></div>
                      <div class="card__info__description"><Skeletor width="75%" height="16"/></div>
                    </div>
                  </div>
                </div>
              </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { onMounted, ref } from 'vue';
import moment from 'moment';

export default {
   
  setup(){
    //const router = useRouter();
    //const route = useRoute();
    const store = useStore();
    const { t } = useI18n();
    const profileData = ref();
    const loadedData = ref(false)

    onMounted(async () => {
      try {
        //profileData.value = await store.dispatch('forgeUsers_profileResume',route.params.id);
        //profileData.value = await store.dispatch('forgeUsers_profileDetail',route.params.id);
        loadedData.value = true;      
      } catch (error) {
        store.dispatch('notifications_create', { text: t(`notifications.generic`) });
      }
    });

    function getImage(path) {
      return path ? `${process.env.VUE_APP_CDN_URL_USER}${path}` : null;
    }
    function formatDate(dateTime){
      if (dateTime == null) {
        return t(`apply.current`)
      }
      return moment(dateTime).format("YYYY");
    }

    return{
      profileData,
      loadedData,
      getImage,
      formatDate,
    }

  }

}
</script>

<style lang="scss" scoped>
  @import '~vue-skeletor/dist/vue-skeletor.css';

  
  .my-photos__item {
    display: flex;
    flex-direction: row;
    img {
      width: 200px;
      margin-right: 12px!important;
      height: auto;
      object-fit: cover;
    }
  }

  .button--orange {
    background: $orange;
    position: fixed;
    right: $margin-base;
    bottom: $margin-base;
    padding: $margin-milli $margin-mega;
    z-index: 13;
    margin: 0;
  }

  .apply-detail__cover {
    width: 100%;
    // height: 160px;
    position: absolute;
    z-index: 0;
    height: 296px;
    background: url('~@/assets/profile-bg.svg'), linear-gradient(180deg, #e87b1b 0%, #ffc905 100%);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
      
    img {
      
      width: 100%;
      height: 296px;
      object-fit: cover;
    }
  }

  .apply-detail__information {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: $margin-kilo;

    &__photo {
      width: 140px;
      height: 140px;
      background: $white;
      border-radius: 50%;
      flex-shrink: 0;
      background-size: cover;
      background-position: center center;
    }

    &__details {
      display: grid;
      grid-template-columns: 1fr;
      gap: 16px;

      div {
        display: flex;
        flex-direction: column;

        b {
          font-family: $font-palanquin;
          font-weight: 500;
          @include font-settings(kilo,base);
        }
      }

      @media (min-width: $break-md) {
        grid-template-columns: 1fr 1fr;
      }
    }
  }
  
  .card-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    &--games {
      flex-direction: row!important;
      flex-basis: 100%!important;

      .card--games {
        width: 100%!important;
      }
    }

    @media (min-width: $break-md) {
      
    flex-direction: row;
    flex-basis: 50%;
    }

    .card {
      margin: 4px;
      background: #eee;
      border-radius: 4px;
      padding: $margin-milli $margin-base;

      @media (min-width: $break-md) {
        
      width: calc(50% - 8px);
      }
     
      &__info {
        div {
          padding: 4px 0px;
        }
        &__title {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 4px;
          border-bottom: 1px solid #bdbdbd;
          padding-bottom: 8px!important;
        }
        
        &__status {
          color: $white;
          background: $blue;
          border-radius: 24px;
          margin: $margin-milli 0;
          padding: 4px 16px!important;
          font-size: 13px;
          width: fit-content;
          text-transform: uppercase;
          font-weight: bold;

          &--Completed {
            background: $lightgreen;
          }

          &--Pending {
            background: $red;
          }

          &--InProgress {
            background: $yellow;
          }
        }
      }
      &--games {
        display: flex;
        flex-direction: row;
        .card__image {
          padding: 4px 16px 4px 0px;
          img { width:100px; height: auto; }
        }
        .card__info {
          width: 100%;
        }
      }

    }
  }

  .container {
    padding: 0 $margin-base;

    @media (min-width: $break-sm) {
      padding: 0;
    }

    @media (min-width: $break-md) {
      padding: 0 $margin-base;
    }

    @media (min-width: $break-lg) {
      padding: 0;
    }
  }

  .section-container {
    background: $white;
    border: 1px solid #E0E0E0;
    border-radius: $margin-small;
    padding: $margin-kilo;

    h3 {
      display: flex;
      align-items: center;
      gap: $margin-milli;
      color: $orange!important;
      font-family: $font-palanquin;
      font-size: 21px!important;
      line-height: 29px!important;

      span {
        color: $orange!important;
      }
    }
  }

  .new-search {

    @media (min-width: $break-md) {
      padding: $margin-mega;
    }

    &__grid {
      display: grid;
      gap: $margin-kilo;

      @media (min-width: $break-md) {
        grid-template-columns: 1fr 1fr;
      }
    }
  }
  

  .new-search {
    text-align: left;

    .detail-skeleton-container {
      .vue-skeletor {
        margin-bottom: 8px
      }
    }

    p {
      text-shadow: none;
      font-family: $font-opensans;
      color: $gray;
      font-weight: 400;
      @include font-settings(base,base);
      margin-bottom: $margin-base;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      margin-bottom: $margin-base;

      @media (min-width: $break-md) {
        flex-direction: row;
        margin: 0;
      }
      
    }

    &__title {
      margin-bottom: $margin-base;
    }

    h3 {
      color: $orange;
      text-shadow: none;
      @include font-settings(giga, mega);
      padding: 0 $margin-kilo $margin-base 0;
    }

    img {
      border-radius: 8px;
      margin: 0;
    }

    hr {
      margin-top: $margin-kilo;
    }

    .table-container {
      overflow-x: auto;

      @media (min-width: $break-sm) {
        &::-webkit-scrollbar-track {
          border-radius: 100px;
          background-color: rgba(0,0,0,.1);
          margin: 4px 0;
        }
        
        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
          background-color: transparent;
          margin: 4px 0;
        }
        
        &::-webkit-scrollbar-thumb {
          border-radius: 100px;
          background: $gray;
          margin: 4px 0;
          position: absolute;
        }
      }
    }

    table {
      font-size: 14px;
      width: 100%;
      color: #101010;
      min-width: 830px;

      .material-icons {
        color: $lightgreen;
      }
    }

    thead {
      border-bottom: 2px solid $lightgreen;
      padding-bottom: $margin-milli;
      margin-bottom: $margin-milli;
      display: block;
    }

    tr {
      display: grid;
      grid-template-columns: repeat(6, minmax(0, 1fr));
      text-align: left;
      gap: $margin-milli;
    }

    tbody {

      tr {
        border-bottom: 1px solid $lightgray;
        padding-bottom: $margin-milli;
        margin-bottom: $margin-milli;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

.test-forge{
  max-width: 400px;
  margin-top: 40px;
  padding: 24px 4%;
  display: flex;
  flex-flow: column nowrap;
  gap: 16px;
  &__skills{
    display: flex;
    flex-flow: column nowrap;
    gap: 8px;
  }
  &__skill{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    &__name{
      font-family: Palanquin Dark;
      font-weight: bold;
      font-size: 16px;
      line-height: 18px;
      color: $mediumgray;
    }
    &__score{
      i{
        padding-left: 8px;
        color: $lightgray;
      }
      .star-painted{
        color: #FFC905;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
      }
    }
  }
}

</style>
